import { FileImage } from "lucide-react";

export default function PptxEditor({ slides, selectedSlide, onSelect, onEditBlock }) {
  if (!slides?.length) return <div className="preview-empty">未检测到幻灯片内容</div>;

  return (
    <div className="pptx-preview">
      {slides.map((slide, slideIdx) => (
        <div
          key={slideIdx}
          className={`ppt-slide-card ${slideIdx === selectedSlide ? "selected" : ""}`}
          onClick={() => onSelect(slideIdx)}
        >
          <div className="slide-head">
            <span>幻灯片 {slide.number}</span>
            <span className="slide-count">{slide.blocks.length} 个文本块</span>
          </div>
          <div className="slide-body">
            {slide.imageUrls.map((url, i) => (
              <img key={i} src={url} alt="" className="slide-image" />
            ))}
            <div className="slide-blocks">
              {slide.blocks.map((block, blockIdx) => (
                <label key={block.id} className="slide-block">
                  <span>{blockIdx + 1}</span>
                  <textarea
                    value={block.text}
                    rows={Math.max(1, Math.min(6, Math.ceil(block.text.length / 24)))}
                    onClick={(e) => e.stopPropagation()}
                    onChange={(e) => onEditBlock(slideIdx, blockIdx, e.target.value)}
                    placeholder="点击编辑此文本"
                  />
                </label>
              ))}
              {!slide.blocks.length && (
                <div className="slide-no-text">
                  <FileImage size={18} />
                  此页仅含图片或图形
                </div>
              )}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
